import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Cookies from 'js-cookie'

import {addTeigiFunction} from '../cm_parts/js/TeigiFunction';
import settings from '../../settings.json';
import '../cm_parts/css/cm_list_body.css';
import '../cm_parts/css/teigi.css';


export default class Teigi extends Component{
  state={
    authObj:{},
    teigi_list:[],
    add_teigi:false,

    add_tonya_name_f:'',
    add_tonya_name:'',
    add_tonya_check_zaiko:null,
    add_tonya_priority:null,
    add_tonya_ht:null,
    add_tonya_status:'on',
    add_tonya_order_frequency:null,
    add_tonya_shipping_date_1:null,
    add_tonya_shipping_date_1_2:null,
    add_tonya_order_style:null,
    add_tonya_shipping_date_2:null,
    add_tonya_shipment_confirmation_method:null,
    add_tonya_ship_check_keyword:null,
    add_tonya_domain:null,
    add_tonya_url:null,

    click_updata:false,
    updata_tonya_id:null
    
  }


  componentDidMount () {
    let my_token = Cookies.get('_replace_token');
    if(my_token===undefined){
      window.location.href = '/login';
    }


    let staff_token = Cookies.get('_replace_token');
		let staff_name = Cookies.get('_replace_staff');
		this.setState({authObj:{"token":staff_token, "name":staff_name}})

    let teigi_list = addTeigiFunction.getTonyaList(staff_token, staff_name);
    this.setState({teigi_list:teigi_list});

    console.dir(teigi_list);
  }




  render(){

    var addTeigiClick = async (e) => {
      console.log('クリック add');
      this.setState({add_teigi:true});
    }

    var closeAddTeigi = async (e) => {
      this.setState({add_teigi:false});
    }

    var handleInputChange = async (e) => {
      this.setState({ [e.target.name]: e.target.value });
    }


    const handleSubmitAddTeigiButton = async (e) => {
      console.dir(e.target);
      e.preventDefault();
      let _obj = {};
      for (let i = 0; i < e.target.length; i++) {
        _obj[e.target[i].name] = e.target[i].value;
      }
      console.dir(_obj);

      if(this.state.click_updata===false){
        let _res = addTeigiFunction.postNewTonyaData(_obj, this.state.authObj);
      }else{
        let _res = addTeigiFunction.postUpdataTonyaData(_obj, this.state.authObj);
      }
      
      this.setState({add_teigi:false});
      this.setState({click_updata:false});
      
    }


    var clickEditTonyaButton = async (e) => {
      console.dir(e.target.dataset);
      let tonya_id = Number(e.target.dataset.tonya_id);

      this.setState({click_updata:true});
      this.setState({updata_tonya_id:tonya_id});

      for (let i = 0; i < this.state.teigi_list.length; i++) {
        if(this.state.teigi_list[i].id===tonya_id){
          console.log('ガチャ');
          console.dir(this.state.teigi_list[i]);
          this.setState({add_tonya_name_f:this.state.teigi_list[i].tonya_name_f});
          this.setState({add_tonya_name:this.state.teigi_list[i].tonya_name});
          this.setState({add_tonya_check_zaiko:this.state.teigi_list[i].check_zaiko});
          this.setState({add_tonya_priority:this.state.teigi_list[i].priority});
          this.setState({add_tonya_ht:this.state.teigi_list[i].HT});
          this.setState({add_tonya_status:this.state.teigi_list[i].tonya_status});
          this.setState({add_tonya_order_frequency:this.state.teigi_list[i].order_frequency});
          this.setState({add_tonya_shipping_date_1:this.state.teigi_list[i].shipping_date_1});
          this.setState({add_tonya_shipping_date_1_2:this.state.teigi_list[i].shipping_date_1_2});
          this.setState({add_tonya_order_style:this.state.teigi_list[i].order_style});
          this.setState({add_tonya_shipping_date_2:this.state.teigi_list[i].shipping_date_2});
          this.setState({add_tonya_shipment_confirmation_method:this.state.teigi_list[i].shipment_confirmation_method});
          this.setState({add_tonya_ship_check_keyword:this.state.teigi_list[i].ship_check_keyword});
          this.setState({add_tonya_domain:this.state.teigi_list[i].domain});
          this.setState({add_tonya_url:this.state.teigi_list[i].url});
          
          break;
        }

      }

      this.setState({add_teigi:true});
    }


    return (
      <div className="teigi-area" >

        <div className="board-area mb-5 px-3 py-2 teigi-table"  >
          <div className="row align-item-center logo-area " >
            <a href="/cm-list" className="col-1"><img className=" top-logo" src={"./images/logo192.jpg"} /></a>
            <div className="col-1 ">定義</div>
            <div className="col-1 "><a href="/cm-list-settings">その他設定</a></div>
          </div>

			  	<table>
			  		<thead>
			  			<tr className="table-row sticky-top bg-secondary text-white">
                <td className="table-col nowrap">No.</td>
			  				<td className="table-col nowrap">ID</td>
                <td className="table-col nowrap">ファイル名</td>
			  				<td className="table-col nowrap">表示名</td>
                <td className="table-col nowrap">ステータス</td>
			  				<td className="table-col nowrap">優先度</td>
                <td className="table-col nowrap">在庫更新頻度</td>
			  				<td className="table-col nowrap">HT</td>
			  				<td className="table-col nowrap">発注頻度</td>
                <td className="table-col nowrap">発注締め切り時間</td>
                <td className="table-col nowrap">発送先</td>
                <td className="table-col nowrap">問屋が発送するまでにかかる日数</td>
                <td className="table-col nowrap">倉庫に届くまでの日数</td>
                <td className="table-col nowrap">発注方法</td>
                <td className="table-col nowrap">出荷確認方法</td>
                <td className="table-col nowrap">出荷確認に必要な要素</td>
                <td className="table-col nowrap">発注ページのURL</td>
			  			</tr>
			  		</thead>

            <tbody>
              {this.state.teigi_list.map((row, index)=>{
                

                return(
                  
                  <tr key={'t_'+row.id} className='table-row'>
                    <td className="table-col nowrap ">{index+1}</td>
                    <td className="table-col nowrap ">
                      <span
                        className="mx-1 text-primary click-pointer-elem"
                        data-tonya_id={row.id}
                        onClick={event=>clickEditTonyaButton(event)}
                      >
                        {row.id}
                      </span>
                    </td>
                    <td className="table-col nowrap ">{row.tonya_name_f}</td>
                    <td className="table-col nowrap ">{row.tonya_name}</td>
                    <td className="table-col nowrap ">{row.tonya_status}</td>
                    <td className="table-col nowrap ">{row.priority}</td>
                    <td className="table-col nowrap ">{row.check_zaiko}</td>
                    <td className="table-col nowrap ">{row.HT}</td>
                    <td className="table-col nowrap ">{row.order_frequency}</td>
                    <td className="table-col nowrap ">{row.shipping_date_2}</td>

                    <td className="table-col nowrap ">{row.where_ship}</td>

                    <td className="table-col nowrap ">{row.shipping_date_1}</td>
                    <td className="table-col nowrap ">{row.shipping_date_1_2}</td>
                    <td className="table-col nowrap ">{row.order_style}</td>
                    <td className="table-col nowrap ">{row.shipment_confirmation_method}</td>
                    <td className="table-col nowrap ">{row.ship_check_keyword}</td>
                    <td className="table-col nowrap ">
                      {row.url!=='メール発注' ? 
                        <><a href={row.url} target="_blank" className="text-decoration-none">{row.url}</a></> 
                        : <>メール発注</>
                      }
                      
                    </td>
                  </tr>
                  
                  


                )


              })}

            </tbody>
          </table>
          {this.state.click_updata===false ? 
            <>
              <Button variant="primary" id="hattyuu-check-board-submit" size="sm" type="submit" className="mt-2"  onClick={event=>addTeigiClick(event)}>
					  		問屋さん定義をシステムに新規追加
					  	</Button>
            </>
            : <></>
          }

        </div>


        {this.state.add_teigi ?
          <>
            <Form onSubmit={handleSubmitAddTeigiButton} className="form-control-select add-teigi-table-form">
              {this.state.click_updata===false ? <div className="text-center my-2">追加フォーム</div> : <div className="text-center my-2">編集フォーム</div>}
              
              <table className="">
                <tbody>
                  <tr >
                    <td>問屋ファイル名</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_name_f"
                        placeholder="ヒロウン在庫.xlsx（メーカー在庫）"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_name_f}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>問屋名</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_name"
                        placeholder="ヒロウン在庫（メーカー在庫）"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_name}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>在庫更新頻度</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_check_zaiko"
                        placeholder="day or week"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_check_zaiko}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>優先度</td>
                    <td>
                      <input
								  			type="number"
								  			name="add_tonya_priority"
                        placeholder="100"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_priority}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>ハンドリングタイム</td>
                    <td>
                      <input
								  			type="number"
								  			name="add_tonya_ht"
                        placeholder="3"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_ht}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>ステータス</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_status"
                        placeholder="on"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_status}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>発注頻度</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_order_frequency"
                        placeholder="0,1,2,3,4,5,6（コンマ区切り）"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_order_frequency}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>問屋が発送までにかかる日数</td>
                    <td>
                      <input
								  			type="number"
								  			name="add_tonya_shipping_date_1"
                        placeholder="1"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_shipping_date_1}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>倉庫に届くまでの日数</td>
                    <td>
                      <input
								  			type="number"
								  			name="add_tonya_shipping_date_1_2"
                        placeholder="1"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_shipping_date_1_2}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>発注スタイル</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_order_style"
                        placeholder="csv"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_order_style}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>発注締切時刻</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_shipping_date_2"
                        placeholder="11 , 11.3 , 11.45（ . のあとはminutes）"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_shipping_date_2}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>出荷確認方法</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_shipment_confirmation_method"
                        placeholder="Web or メール"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_shipment_confirmation_method}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>出荷確認時必要な要素</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_ship_check_keyword"
                        placeholder="発注番号,JAN (コンマ区切り)"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_ship_check_keyword}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>ドメイン</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_domain"
                        placeholder="mevius.welfan.jp"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_domain}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                  <tr >
                    <td>発注用トップページのURL</td>
                    <td>
                      <input
								  			type="text"
								  			name="add_tonya_url"
                        placeholder="https://mevius.welfan.jp/default.aspx"
								  			className="form-control form-control-sm border"
								  			value={this.state.add_tonya_url}
								  			onChange={event=>handleInputChange(event)}
								  		/>
                    </td>
                  </tr>
                </tbody>
							</table>

							<Button variant="primary" id="" size="sm" type="submit" className="mt-2">
                {this.state.click_updata===false ? <>登録する</> : <>変更する</>}
							</Button>

							<div className="jan-info-close-button" onClick={event=>closeAddTeigi(event)}><i className="bi bi-x-circle"></i></div>

						</Form>
          </>
          :
          <></>
        }


        <div>
          memo:
          <ul>
            <li>発注頻度: 月曜 0, 火曜 1 .... 毎日 0,1,2,3,4,5,6 </li>
            <li>発注締め切り時間: 11時 -> 11 のみ、 11:30 -> 11.3 , 11:45 -> 11.45</li>
            <li>問屋が発送するまでにかかる日数: 当日発送 -> 0, 翌日 -> 1 </li>
          </ul>
        </div>
      </div>
    );
  }
}

